import { Yield } from '../../abacus/interfaces/yield.interface'

export const targetUserYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
